export const VEHICLE_ASSIGNED_TEXT = {
	missingValue: 'NN',
};

/**
 * Stable id for the plate tooltip; the from/to pair keeps it unique per grid
 * cell so multiple `VehicleAssigned` in one page don't collide.
 *
 * @param {string} fromStationId
 * @param {string} toStationId
 * @returns {string}
 */
export const buildTooltipId = (fromStationId, toStationId) =>
	`tooltip-plate${fromStationId}/${toStationId}`;
